import { render, staticRenderFns } from "./EditResellerComponent.vue?vue&type=template&id=c8c64e52&"
import script from "./EditResellerComponent.vue?vue&type=script&lang=js&"
export * from "./EditResellerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports